export default function Hero() {
  return (
    <section
      id="home"
      className="relative w-full min-h-[760px] md:min-h-[820px] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20painterly%20landscape%20with%20deep%20emerald%20green%20rolling%20hills%20and%20soft%20warm%20golden%20light%20at%20sunrise%2C%20minimal%20editorial%20illustration%20with%20gentle%20brush%20texture%2C%20serene%20uplifting%20mood%2C%20smooth%20gradient%20sky%20transitioning%20from%20deep%20forest%20green%20to%20warm%20cream%2C%20clean%20negative%20space%20on%20the%20left%20side%20for%20text%2C%20premium%20fintech%20banner%20art&width=1920&height=1080&seq=nano-hero-bg-01&orientation=landscape"
        alt="VF Money background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 via-primary-900/60 to-primary-700/30"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-28 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur border border-background-50/25 text-background-50 text-xs font-medium px-3.5 py-1.5 rounded-full mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              Đã có hơn 5.000 khách hàng tin tưởng
            </div>

            <h1 className="font-heading text-background-50 text-4xl md:text-6xl leading-[1.05] tracking-tight mb-6">
              Quy trình đăng ký nhanh,<br />
              <span className="text-accent-400">tiền sẽ chuyển thẳng</span> vào tài khoản ngân hàng của bạn.
            </h1>

            <p className="text-background-100/90 text-base md:text-lg max-w-xl mb-8">
              Đăng ký 100% online chỉ trong 3 phút. Không cần thế chấp, không cần
              chứng minh thu nhập phức tạp. Tiền giải ngân trong vòng tối đa 30 phút.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 text-base font-semibold px-7 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Tải ứng dụng
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 backdrop-blur border border-background-50/30 text-background-50 text-base font-semibold px-7 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                Tìm hiểu thêm
              </a>
            </div>

            <div className="grid grid-cols-3 gap-3 max-w-xl">
              {[
                { num: "10M+", label: "Hạn mức tối đa", unit: "VND" },
                { num: "30 phút", label: "Giải ngân siêu tốc", unit: "" },
                { num: "100%", label: "Online", unit: "" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="bg-background-50/10 backdrop-blur border border-background-50/20 rounded-2xl px-4 py-4"
                >
                  <p className="text-background-50 text-xl md:text-2xl font-bold leading-none">
                    {item.num}
                    {item.unit && (
                      <span className="text-xs font-medium text-background-100/80 ml-1">{item.unit}</span>
                    )}
                  </p>
                  <p className="text-background-100/80 text-xs md:text-sm mt-2">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Phone mockup */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end animate-fade-up">
            <div className="relative">
              <div className="absolute -inset-8 bg-accent-500/30 blur-3xl rounded-full"></div>
              {/* Outer phone frame with metallic bezel */}
              <div className="relative w-[300px] md:w-[340px] aspect-[300/620] bg-foreground-950 rounded-[48px] p-[14px] border-[1px] border-foreground-800 shadow-2xl animate-float">
                {/* Left side buttons */}
                <div className="absolute left-[-3px] top-[120px] w-[3px] h-[28px] bg-foreground-800 rounded-l-sm"></div>
                <div className="absolute left-[-3px] top-[156px] w-[3px] h-[56px] bg-foreground-800 rounded-l-sm"></div>
                <div className="absolute left-[-3px] top-[220px] w-[3px] h-[56px] bg-foreground-800 rounded-l-sm"></div>
                {/* Right side button */}
                <div className="absolute right-[-3px] top-[170px] w-[3px] h-[72px] bg-foreground-800 rounded-r-sm"></div>

                {/* Inner screen */}
                <div className="w-full h-full rounded-[38px] bg-gradient-to-b from-secondary-100 to-background-50 overflow-hidden relative">
                  {/* Dynamic Island */}
                  <div className="absolute top-3 left-1/2 -translate-x-1/2 z-20">
                    <div className="w-[110px] h-[32px] bg-foreground-950 rounded-full flex items-center px-3 gap-2">
                      <div className="w-3 h-3 rounded-full bg-foreground-800"></div>
                      <div className="w-3 h-3 rounded-full bg-foreground-800"></div>
                    </div>
                  </div>

                  {/* Top status bar */}
                  <div className="flex items-center justify-between px-6 pt-[48px] pb-2 text-foreground-900 text-[11px] font-semibold">
                    <span>9:41</span>
                    <div className="flex items-center gap-1">
                      <i className="ri-signal-tower-line text-xs"></i>
                      <i className="ri-wifi-line text-xs"></i>
                      <i className="ri-battery-fill text-xs"></i>
                    </div>
                  </div>

                  <div className="px-5 pt-4">
                    <p className="text-foreground-950 font-heading text-2xl leading-tight">
                      Xin chào!
                    </p>
                    <p className="text-foreground-600 text-xs mt-1">
                      Bắt đầu hành trình tài chính của bạn ngay hôm nay.
                    </p>

                    <div className="mt-5 bg-background-50 rounded-2xl border border-background-200 p-5 relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-full blur-2xl"></div>
                      <div className="relative">
                        <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center mx-auto">
                          <i className="ri-money-dollar-circle-line text-primary-600 text-xl"></i>
                        </div>
                        <p className="text-center text-[10px] tracking-widest text-foreground-500 mt-3 font-semibold">
                          HẠN MỨC TỐI ĐA LÊN ĐẾN
                        </p>
                        <p className="text-center text-primary-600 font-bold text-2xl mt-1">
                          10.000.000 <span className="underline">đ</span>
                        </p>
                        <p className="text-center text-foreground-600 text-[11px] mt-2 px-2">
                          Đăng ký hồ sơ chỉ trong 3 phút. Giải ngân tối đa 30 phút.
                        </p>
                        <button className="mt-4 w-full bg-accent-500 text-background-50 text-sm font-semibold py-2.5 rounded-full cursor-pointer whitespace-nowrap">
                          Đăng ký ngay →
                        </button>
                      </div>
                    </div>

                    <div className="mt-4 grid grid-cols-3 gap-2">
                      {[
                        { icon: "ri-flashlight-line", label: "Giải ngân 30 phút" },
                        { icon: "ri-eye-line", label: "Lãi suất minh bạch" },
                        { icon: "ri-shield-check-line", label: "Bảo mật an toàn" },
                      ].map((b) => (
                        <div
                          key={b.label}
                          className="bg-background-50 border border-background-200 rounded-xl p-2 text-center"
                        >
                          <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center mx-auto">
                            <i className={`${b.icon} text-primary-600 text-sm`}></i>
                          </div>
                          <p className="text-[9px] text-foreground-700 font-medium mt-1.5 leading-tight">
                            {b.label}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Bottom nav */}
                  <div className="absolute bottom-0 left-0 right-0 bg-background-50 border-t border-background-200 px-5 py-2 flex items-center justify-around">
                    <div className="flex flex-col items-center text-primary-600">
                      <div className="bg-primary-500 text-background-50 px-3 py-1 rounded-md flex items-center gap-1">
                        <i className="ri-home-5-fill text-xs"></i>
                        <span className="text-[10px] font-semibold">Trang chủ</span>
                      </div>
                    </div>
                    <div className="flex flex-col items-center text-foreground-500">
                      <i className="ri-bank-card-line text-lg"></i>
                      <span className="text-[9px] mt-0.5">Khoản vay</span>
                    </div>
                    <div className="flex flex-col items-center text-foreground-500">
                      <i className="ri-user-line text-lg"></i>
                      <span className="text-[9px] mt-0.5">Cá nhân</span>
                    </div>
                  </div>

                  {/* Home indicator */}
                  <div className="absolute bottom-[3px] left-1/2 -translate-x-1/2 z-20">
                    <div className="w-[120px] h-[5px] bg-foreground-950 rounded-full opacity-60"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}